import React from 'react';
import Iconify from 'src/components/iconify';
import { Box, Button, Card, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import RenderField from '../../risk-register/render-field';
const EscalationTable = ({ data }) => {
    console.log("🚀 ~ EscalationTable ~ data:", data)
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };
    return (
        <Card>
            <Box p={3}>
                <Typography className=" Escalation-view-main-heading"> Escalation Report</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
                <Box sx={{ position: 'relative' }}>
                    <Typography variant="h4" className="pull-left mt-2 ribbon ribbon-bookmark ribbon-success">
                       Risk  Escalation Details{' '}
                    </Typography>
                </Box>
                <Box>
                    <Button
                        className='dark-button'
                        sx={{ marginRight: '20px', marginTop: '22px' }}
                        onClick={goBack}
                        size="md"
                        variant="contained"
                        startIcon={<Iconify icon="ep:back" width={16} />}
                    >
                        Go Back
                    </Button>
                </Box>
            </Box>
            <Box
                p={4}
                mt={4}
                rowGap={3}
                columnGap={20}
                display="grid"
                gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(3, 1fr)',
                }}
            >
                <RenderField label=" Escalation ID" value={data?.escalation_id} />
                <RenderField label=" Original Risk ID" value={data?.identification_and_assessment?.risk_id} />
                <RenderField label=" Reason for Escalation " value={data?.reason} />
            </Box>
            <Divider />
            <Box
                p={4}
                rowGap={3}
                columnGap={20}
                display="grid"
                gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(3, 1fr)',
                }}
            >
                <RenderField label="Escalation Leve" value={data?.escalation_level?.name} />
                <RenderField label="Action Required Taken" value={data?.action_required} />
                <RenderField label=" Escalation Date" value={data?.date} />
            </Box>
            <Divider />
          
        </Card>
    );
};

export default EscalationTable;
